import { render, staticRenderFns } from "./CytomineChannel.vue?vue&type=template&id=4b5dd6dc&scoped=true"
import script from "./CytomineChannel.vue?vue&type=script&lang=js"
export * from "./CytomineChannel.vue?vue&type=script&lang=js"
import style0 from "./CytomineChannel.vue?vue&type=style&index=0&id=4b5dd6dc&prod&lang=css"
import style1 from "./CytomineChannel.vue?vue&type=style&index=1&id=4b5dd6dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5dd6dc",
  null
  
)

export default component.exports